import { formatHttpsUrl } from '@/lib/urlFormatter'

export function normalizeHttpsUrl(val: unknown): string | null {
  const s = (val || '').toString().trim()
  if (!s) return null
  return formatHttpsUrl(s)
}

/** True when the value is a legal-page URL, not scraped business description text. */
export function isLikelyLegalPageUrl(val: unknown): boolean {
  const s = (val || '').toString().trim()
  if (!s) return false
  if (s.length > 400) return false
  if (/\s/.test(s) && !/^https?:\/\//i.test(s)) return false
  try {
    const normalized = /^https?:\/\//i.test(s) ? s : `https://${s}`
    const host = new URL(normalized).hostname
    return Boolean(host && host.includes('.'))
  } catch {
    return false
  }
}

export function legalLinkForSubmit(val: unknown, websiteFallback: string | null): string | null {
  if (!isLikelyLegalPageUrl(val)) return websiteFallback
  return normalizeHttpsUrl(val) || websiteFallback
}
